import { Box, Grid, Skeleton, Typography, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useGetOfferContentQuery } from '@/services/api/helpApiSlice';
import React, { FC, ReactElement } from 'react';

export const OfferPage: FC = (): ReactElement => {
  const { data, isLoading } = useGetOfferContentQuery();

  const isMobile: boolean = useMediaQuery((theme: Theme): string => theme.breakpoints.down('sm'));

  return (
    <Grid container={true} direction={'column'} spacing={isMobile ? 2 : 4} sx={{ minHeight: '100%' }} wrap={'nowrap'}>
      <Grid item={true}>
        <Typography
          variant={'h1'}
          sx={{ fontSize: isMobile ? '24px !important' : '48px', lineHeight: isMobile ? '32px !important' : '56px' }}>
          {'Публичная оферта'}
        </Typography>
      </Grid>
      <Grid item={true} xs={true}>
        {isLoading ? (
          <Skeleton height={'20px'} />
        ) : (
          <Box className={'offer-content'} dangerouslySetInnerHTML={{ __html: data?.content ?? '' }} />
        )}
      </Grid>
    </Grid>
  );
};
